import React from 'react'
import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Box, styled, SxProps, Theme } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

interface AccordionCompactProps {
  heading?: React.ReactNode;
  rightHeading?: React.ReactNode;
  defaultExpanded?: boolean;
  sxInner?: SxProps<Theme>;
  bigHeader?: boolean;
  children: React.ReactNode;
  onExpandCollapse?: (expanded: boolean) => void;
}
const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  height: '40px', // Set your desired height here
  minHeight: '40px', // Ensure the minimum height is also set
  '&.Mui-expanded': {
    minHeight: '40px', // Ensure the expanded state also respects the height
  },
}));
export default function AccordionCompact(props: Readonly<AccordionCompactProps> & Omit<AccordionProps, 'children' | 'defaultExpanded'>) {
  const { children, heading, defaultExpanded, sx, rightHeading, sxInner, bigHeader, onExpandCollapse } = props;

  return (
    <Accordion
      onChange={(e, expanded) => onExpandCollapse?.(expanded)}
      elevation={4}
      sx={sx}
      defaultExpanded={defaultExpanded}>
      {!bigHeader && <CustomAccordionSummary
        expandIcon={<ExpandMore />}
      >
        <Box width='100%' display='flex' justifyContent='space-between' mr={2}>{heading}{rightHeading}</Box>
      </CustomAccordionSummary>}
      {bigHeader && <AccordionSummary
        expandIcon={<ExpandMore />}

      >

        <Box width='100%' display='flex' justifyContent='space-between' mr={2}>{heading}{rightHeading}</Box>
      </AccordionSummary>}
      <AccordionDetails sx={sxInner}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}
